import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=4871f4de&scoped=true&"
import script from "./DataTable.vue?vue&type=script&lang=js&"
export * from "./DataTable.vue?vue&type=script&lang=js&"
import style0 from "./DataTable.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./DataTable.vue?vue&type=style&index=1&lang=stylus&"
import style2 from "./DataTable.vue?vue&type=style&index=2&lang=css&"
import style3 from "./DataTable.vue?vue&type=style&index=3&lang=stylus&"
import style4 from "./DataTable.vue?vue&type=style&index=4&id=4871f4de&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4871f4de",
  null
  
)

export default component.exports